<template>
	<div class="ms-button">
		<button
			class="ms-button-item"
			:class="[`justify-${align}`, type, cssClass, { focused: focused }]"
			:disabled="disabled"
			v-on="listeners"
			:tabIndex="tabIndex"
			:style="btnCustom"
		>
			<div
				:class="icon"
				v-if="icon && iconPlacement == 'left'"
				class="ms-mgr-8px"
			></div>
			<div
				class="ms-button-text"
				:class="{ 'is-bold': isBold, 'is-uppcase': uppcaseText }"
				:style="fontCustom"
				v-html="title"
			></div>
			<div
				:class="icon"
				v-if="icon && iconPlacement == 'right'"
				class="ms-mgl-8px"
			></div>
			<div :class="icon" v-if="icon && iconPlacement == 'center'"></div>
			<div v-if="subtext" class="subtext ms-pdl-4px">{{ subtext }}</div>
			<slot></slot>
		</button>
	</div>
</template>
<script>
export default {
	name: 'msButton',
	props: {
		//Tiêu đề hiện thị trên button
		title: {
			defualt: null,
			type: String,
		},
		//Icon đi kìm với title của button
		icon: {
			default: null,
			type: [String],
		},
		//Chỉnh vị trí cho text trong button
		align: {
			default: 'center',
			type: String,
		},
		//Loại button gồm 3 loại primary/secondary/third/four để hiện thị style tương ứng
		type: {
			default: 'primary',
			type: String,
		},
		/**
		 * css để bên ngoài control có thể custom lại được style của button
		 */
		cssClass: {
			default: null,
			type: String,
		},
		/**
		 * Trạng thái button disabled
		 */
		disabled: {
			default: false,
			type: Boolean,
		},
		isBold: {
			default: false,
			type: Boolean,
		},
		iconPlacement: {
			default: 'left',
			type: String,
		},
		tabIndex: {
			default: 0,
			type: Number,
		},
		fontSize: {
			default: null,
			type: Number,
		},
		radius: {
			default: null,
			Type: Number,
		},
		uppcaseText: {
			default: false,
			type: Boolean,
		},
		subtext: {
			default: null,
			type: String,
		},
	},
	data() {
		return {
			focused: false,
		};
	},
	computed: {
		//Sự kiện từ 1 dòng dữ liệu emit ra ngoài
		listeners() {
			const me = this;
			return {
				click: (event) => {
					me.$emit('click', event);
				},
				mousedown: (event) => {
					event.preventDefault();
				},
				keydown: (event) => {
					me.$emit('keydown', event);
				},
				focus: (event) => {
					me.focused = true;
					me.$emit('focus', event);
				},
				blur: (event) => {
					me.focused = false;
					me.$emit('blur', event);
				},
			};
		},
		fontCustom() {
			const me = this;
			if (me.fontSize) {
				return {
					'font-size': `${me.fontSize}px`,
				};
			}
			return null;
		},
		btnCustom() {
			const me = this;

			if (me.radius) {
				return {
					'border-radius': `${me.radius}`,
				};
			}
			return null;
		},
	},
};
</script>
<style scoped lang="scss">
@import '@/assets/scss/_variables.scss';
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msButton.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msButton.scss';
}
</style>

